import { useEffect } from "react";
import { Link, NavLink, Route, Routes } from "react-router-dom";
import { applyTelegramTheme, getTelegram } from "./tg.js";
import { ListPage } from "./pages/List.js";
import { DetailPage } from "./pages/Detail.js";
import { AddPage } from "./pages/Add.js";
import { SettingsPage } from "./pages/Settings.js";
import { CalendarPage } from "./pages/Calendar.js";
import { SchedulesPage } from "./pages/SchedulesPage.js";
import { FailuresPage } from "./pages/FailuresPage.js";

export function App() {
  useEffect(() => {
    const tg = getTelegram();
    if (tg) {
      tg.ready();
      tg.expand();
    }
    applyTelegramTheme();
    const onTheme = () => applyTelegramTheme();
    tg?.onEvent("themeChanged", onTheme);
    return () => tg?.offEvent("themeChanged", onTheme);
  }, []);

  return (
    <div className="mx-auto min-h-screen max-w-md bg-bg pb-16">
      <Routes>
        <Route path="/" element={<ListPage />} />
        <Route path="/items/:id" element={<DetailPage />} />
        <Route path="/add" element={<AddPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/schedules" element={<SchedulesPage />} />
        <Route path="/failures" element={<FailuresPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomNav />
    </div>
  );
}

function NotFound() {
  return (
    <div className="p-6 text-center">
      <div className="text-2xl">404</div>
      <Link to="/" className="text-link">
        На главную
      </Link>
    </div>
  );
}

function BottomNav() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `flex-1 py-3 text-center text-sm ${isActive ? "text-button font-medium" : "text-hint"}`;
  return (
    <nav className="fixed inset-x-0 bottom-0 mx-auto flex max-w-md border-t border-bg-secondary bg-bg">
      <NavLink to="/" end className={linkClass}>
        📋 Список
      </NavLink>
      <NavLink to="/add" className={linkClass}>
        ➕ Добавить
      </NavLink>
      <NavLink to="/calendar" className={linkClass}>
        📅 Календарь
      </NavLink>
      <NavLink to="/settings" className={linkClass}>
        ⚙ Настройки
      </NavLink>
    </nav>
  );
}
